import { client } from "./supabase";

// Comisiones neteadas de un ingreso bancario (transferencia internacional recibida). Santander
// descuenta su comisión de recepción de los USD entrantes; la factura SII recibida no tiene
// débito propio y quedaría huérfana en "Por pagar". Esta tabla puente la vincula al movimiento.
// Ver migración 20260609_comisiones_ingreso_neteadas.sql.

const RUT_SANTANDER = "97036000";
// Las comisiones de recepción son montos chicos (USD 15 + IVA ≈ pocos miles de CLP/USD); el tope
// descarta las facturas de financiamiento/mantención grandes del mismo RUT.
const MONTO_MAX_COMISION_RECEPCION = 50000;

// Comisiones vinculadas a un movimiento, con embed de la factura recibida.
export const getComisionesIngresoNeteadas = async (movimientoBancarioId) => {
  const { data, error } = await client
    .from("comisiones_ingreso_neteadas")
    .select(
      `id, factura_sii_recibida_id,
       factura:facturas_sii_recibidas(id, folio, fecha_emision, monto_total, razon_social_emisor)`
    )
    .eq("movimiento_bancario_id", movimientoBancarioId)
    .order("id");
  if (error) throw error;
  return data || [];
};

// Vincula una factura SII recibida de comisión a un movimiento de ingreso (INSERT).
export const vincularComisionIngreso = async (movimientoBancarioId, facturaId) => {
  const { data, error } = await client
    .from("comisiones_ingreso_neteadas")
    .insert({ movimiento_bancario_id: movimientoBancarioId, factura_sii_recibida_id: facturaId })
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Desvincula una comisión (DELETE por id de la fila puente).
export const desvincularComisionIngreso = async (id) => {
  const { error } = await client.from("comisiones_ingreso_neteadas").delete().eq("id", id);
  if (error) throw error;
};

// Facturas SII recibidas de Santander pendientes, monto chico (comisión de recepción), desde
// 2026-01-01, que NO estén ya vinculadas a ningún movimiento en comisiones_ingreso_neteadas.
export const getFacturasComisionIngresoDisponibles = async (pais) => {
  const { data: yaVinc, error: errVinc } = await client
    .from("comisiones_ingreso_neteadas")
    .select("factura_sii_recibida_id");
  if (errVinc) throw errVinc;
  const excluidas = new Set((yaVinc || []).map((r) => r.factura_sii_recibida_id));

  const { data, error } = await client
    .from("facturas_sii_recibidas")
    .select("id, folio, fecha_emision, monto_total, razon_social_emisor, rut_emisor")
    .eq("pais", pais)
    .like("rut_emisor", `%${RUT_SANTANDER}%`)
    .gte("fecha_emision", "2026-01-01")
    .lt("monto_total", MONTO_MAX_COMISION_RECEPCION)
    .gt("monto_total", 0)
    .order("fecha_emision", { ascending: false });
  if (error) throw error;
  return (data || []).filter((f) => !excluidas.has(f.id));
};
